import { useThemeColors } from '@/shared/theme/useThemeColors';
import { typography } from '@/shared/theme/tokens';

export function PageHeader({ title, description, actions }) {
  const c = useThemeColors();
  return (
    <div style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginBottom: '16px',
      gap: '16px',
      flexWrap: 'wrap',
    }}>
      <div>
        <h1 style={{
          fontFamily: typography.fontFamily.heading,
          fontSize: typography.fontSize['5xl'],
          fontWeight: typography.fontWeight.bold,
          color: c.textPrimary,
          letterSpacing: typography.letterSpacing.tight,
          margin: '0 0 4px',
          lineHeight: 1.2,
        }}>
          {title}
        </h1>
        {description && (
          <p style={{ fontSize: typography.fontSize.md, color: c.textMuted, margin: 0 }}>
            {description}
          </p>
        )}
      </div>
      {actions && <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>{actions}</div>}
    </div>
  );
}
